var React = require('react');

function EmptyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.2485 23.985C17.8579 23.985 17.4524 23.8495 17.1219 23.5937L12.015 19.7116L6.90809 23.5937C6.2472 24.0903 5.37602 24.1204 4.7001 23.6389C4.00916 23.1574 3.70876 22.2696 3.9641 21.4571L5.94679 15.0922L0.764762 11.1649C0.103866 10.6533 -0.166501 9.78056 0.103866 8.98307C0.374233 8.18558 1.08019 7.67398 1.89129 7.67398H8.21487L10.1825 1.35423C10.4379 0.541693 11.1589 0 12 0C12.8411 0 13.5621 0.541693 13.8024 1.35423L15.7701 7.68903H22.0937C22.9198 7.68903 23.6258 8.20063 23.8961 8.99812C24.1665 9.79561 23.8961 10.6683 23.2352 11.1799L18.0682 15.1072L20.0509 21.4721C20.3063 22.2846 20.0059 23.1724 19.3149 23.6539C18.9845 23.8796 18.609 24 18.2335 24L18.2485 23.985Z","fill":"#DFE2E2"}));
}

EmptyInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = EmptyInline;

EmptyInline.default = EmptyInline;
